import * as React from 'react';
import { ApartmentFinishing } from '../../components/ApartmentFinishing';
import { useSelector } from 'react-redux';
import { getTemplateSpecialPromoApartmentFinishing } from '../../selectors/developerV2/templateSpecialPromo/getTemplateSpecialPromoApartmentFinishing';

export const ApartmentFinishingTemplateSpecialPromoContainer: React.FC = () => {
  const apartmentFinishing = useSelector(getTemplateSpecialPromoApartmentFinishing);

  if (!apartmentFinishing?.finishing.length) {
    return null;
  }

  return (
    <ApartmentFinishing
      title={apartmentFinishing.header}
      description={apartmentFinishing.description}
      finishing={apartmentFinishing.finishing}
    />
  );
};
